export const MAX_WIDTH_IMAGE_DESKTOP = 480;
export const MAX_HEIGHT_IMAGE_DESKTOP = 400;

export const MAX_WIDTH_IMAGE_MOBILE = 315;
export const MAX_HEIGHT_IMAGE_MOBILE = 280;
